module.exports = __webpack_public_path__ + "img/web-scraping.b9a67f3a.svg";